import isMobile from '../../plugins/is-mobile.js';

// if(!isMobile(768)) {
//   var target = 98;
// }

if ($('.p-top-hero').length) {
  // hero
  // 変化させる要素
  var elem = $(".p-top-hero");
  // ページトップからの要素の高さ
  var elemO = elem.offset().top;
  // 変化させる要素の高さ
  // var elemH = elem.height();
  var elemH = $(".p-top-introduction").offset().top;
  // ウィンドウの高さ
  var windowH = $(window).height();

  var windowS = $(window).scrollTop();

  if (windowS > elemH - 98) {
    // console.log('aaaaaaaa');
    $('.l-header').addClass('screen-out-top');
    $('.c-mail-box').addClass('screen-out-top');
  } else {
    // console.log('bbbbbbbb');
    $('.l-header').removeClass('screen-out-top');
    $('.c-mail-box').removeClass('screen-out-top');
  }

  $(window).on("scroll", function () {
    // ページトップからの要素の高さ
    var elemO = elem.offset().top;
    // 変化させる要素の高さ
    // var elemH = elem.height();
    var elemH = $(".p-top-introduction").offset().top;
    // ウィンドウの高さ
    var windowH = $(window).height();

    var windowS = $(window).scrollTop();

    if (windowS > elemH - 98) {
      $('.l-header').addClass('screen-out-top');
      $('.c-mail-box').addClass('screen-out-top');
    } else {
      $('.l-header').removeClass('screen-out-top');
      $('.c-mail-box').removeClass('screen-out-top');
    }
  });

}
